// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width:1024px) {
    .auth-page {
        padding: 16px 0 16px 16px;
    }

    .auth-images {
        padding: 24px 16px;
    }

    .auth-images .logo {
        max-width: 246px;
    }

    .auth-images h1 {
        font-size: 42px;
        line-height: 50px;
    }

    .auth-form h2 {
        font-size: 34px;
        line-height: 40px;
    }

    .auth-form .icon {
        margin-bottom: 16px;
    }

    .auth-form {
        padding: 0 16px;
    }

    .auth-form-title {
        margin-bottom: 36px;
    }

    .sidebar {
        background: var(--white);
        position: fixed;
        top: 0;
        left: -100%;
        height: 100dvh;
        min-height: unset;
        overflow: auto;
        z-index: 99;
        transition: all 0.3s ease-in-out;
    }

    .sidebar-link,
    .sidebar-menu .submenu li a {
        padding: 12px 16px;
    }

    .sidebar-link .icon,
    .sidebar-menu .submenu li a .icon {
        min-width: 28px;
        max-width: 28px;
        height: 28px;
        font-size: 24px;
        line-height: 24px;
        margin-right: 16px;
    }

    .close-button {
        display: flex;
    }

    .logo-header {
        padding: 16px;
        min-width: unset;
        max-width: unset;
    }

    .main-header .header-right {
        padding: 16px;
    }

    .profile-dropdown .profile-pic {
        min-width: 38px;
        max-width: 38px;
        height: 38px;
    }

    .profile-dropdown .dropdown-toggle {
        gap: 4px;
    }

    .profile-dropdown .profile-info {
        margin-left: 8px;
    }

    .admin-page {
        padding: 16px;
    }

    .page-section-title {
        font-size: 24px;
        line-height: 28px;
    }

    .buildings-filter,
    .import-data-page .create-building-form {
        padding: 16px;
    }

    .create-building-form .button-group {
        gap: 16px;
    }

    .bar-button {
        display: flex;
    }

    .main-layout::before {
        content: '';
        width: 100%;
        height: 100dvh;
        position: fixed;
        top: 0;
        left: -100%;
        background: #00000030;
        pointer-events: none;
        z-index: 98;
        transition: all 0.3s ease-in-out;
    }

    .sidebar-open .sidebar,
    .sidebar-open .main-layout::before {
        left: 0;
    }

    .sidebar-open {
        overflow: hidden;
    }

    .build-box-title {
        font-size: 20px;
        line-height: 28px;
    }

    .build-details-card {
        padding: 16px;
    }

    .period-table thead th,
    .build-details-card li p {
        font-size: 16px;
        line-height: 24px;
    }

    .import-data-page .create-building-form {
        margin-bottom: 24px;
    }

    .radio_list_import {
        gap: 16px;
    }

    .radio_list_import label span {
        min-width: 200px;
        font-size: 16px;
        line-height: 24px;
        padding: 12px 25px;
    }
}

@media only screen and (max-width:767px) {
    .stat-value {
        font-size: 32px;
        line-height: 40px;
    }


    .auth-images,
    .auth-login-box {
        width: 100%;
    }

    .auth-login-box {
        margin-top: 24px;
    }

    .auth-page {
        padding: 16px;
    }

    .auth-form {
        padding: 0;
        max-width: 100%;
    }

    .auth-images h1 {
        font-size: 34px;
        line-height: 40px;
    }

    .auth-images p {
        font-size: 16px;
        line-height: 24px;
    }

    .auth-form h2 {
        font-size: 32px;
        line-height: 38px;
    }

    .remeber-forgot-box,
    .auth-form-title {
        margin-bottom: 24px;
    }

    .btns {
        font-size: 16px;
        line-height: 22px;
        padding: 12px 24px;
        border-radius: 12px;
    }

    .buildings-filter {
        flex-direction: column;
    }

    .buildings-filter .form-row {
        max-width: 100%;
    }

    .build-details-card.build-full-active {
        padding-right: 16px;
        padding-top: 45px;
    }

    .build-full-active .status {
        top: 16px;
        right: 16px;
        padding: 4px 12px;
        font-size: 14px;
        line-height: 18px;
    }

    .period-table thead th {
        padding: 0 8px 12px;
    }

    .period-table tbody td {
        padding: 12px 8px;
    }

    .auth-row {
        flex-wrap: wrap;
    }

    .auth-images {
        max-width: 100%;
    }

    .uploaded-surface-box {
        margin-top: 24px;
        padding: 16px;
    }

    .uploaded-surface-section .inner-title {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 18px;
    }

    .auth-page .btns {
        border-radius: 12px;
        padding: 12px 24px;
        font-size: 18px;
        line-height: 20px;
    }
}

@media only screen and (max-width:640px) {
    .create-building-form .button-group {
        flex-wrap: wrap;
    }

    .create-building-form .button-group .btns {
        width: 100%;
    }

    .my-team-page .admin-page-title {
        flex-direction: column;
        align-items: flex-start !important;
        gap: 16px !important;
    }

    .my-team-page .admin-page-title .btns {
        margin-left: auto;
    }

    .radio_list_import label,
    .radio_list_import label span {
        width: 100%;
    }

    .uploaded-area-box .dropzone-content p {
        font-size: 16px;
        line-height: 24px;
    }

    .uploaded-surface-item {
        padding: 12px 35px 12px 16px;
    }

    .uploaded-surface-item .remove-btn {
        right: 12px;
    }

    .import-data-page .btns {
        width: fit-content;
        min-width: unset;
    }

    .import-step-date .step {
        min-width: 44px;
        height: 44px;
        font-size: 16px;
        line-height: 24px;
    }

    .import-step-date {
        gap: 80px;
    }

    .import-step-date .step::before {
        width: 70px;
        left: -75px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":"AAAA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;QACxB,eAAe;QACf,MAAM;QACN,WAAW;QACX,cAAc;QACd,iBAAiB;QACjB,cAAc;QACd,WAAW;QACX,gCAAgC;IACpC;;IAEA;;QAEI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;QACf,eAAe;QACf,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,cAAc;QACd,eAAe;QACf,MAAM;QACN,WAAW;QACX,qBAAqB;QACrB,oBAAoB;QACpB,WAAW;QACX,gCAAgC;IACpC;;IAEA;;QAEI,OAAO;IACX;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;;IAGA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,kCAAkC;QAClC,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,WAAW;IACf;AACJ","sourcesContent":["@media only screen and (max-width:1024px) {\n    .auth-page {\n        padding: 16px 0 16px 16px;\n    }\n\n    .auth-images {\n        padding: 24px 16px;\n    }\n\n    .auth-images .logo {\n        max-width: 246px;\n    }\n\n    .auth-images h1 {\n        font-size: 42px;\n        line-height: 50px;\n    }\n\n    .auth-form h2 {\n        font-size: 34px;\n        line-height: 40px;\n    }\n\n    .auth-form .icon {\n        margin-bottom: 16px;\n    }\n\n    .auth-form {\n        padding: 0 16px;\n    }\n\n    .auth-form-title {\n        margin-bottom: 36px;\n    }\n\n    .sidebar {\n        background: var(--white);\n        position: fixed;\n        top: 0;\n        left: -100%;\n        height: 100dvh;\n        min-height: unset;\n        overflow: auto;\n        z-index: 99;\n        transition: all 0.3s ease-in-out;\n    }\n\n    .sidebar-link,\n    .sidebar-menu .submenu li a {\n        padding: 12px 16px;\n    }\n\n    .sidebar-link .icon,\n    .sidebar-menu .submenu li a .icon {\n        min-width: 28px;\n        max-width: 28px;\n        height: 28px;\n        font-size: 24px;\n        line-height: 24px;\n        margin-right: 16px;\n    }\n\n    .close-button {\n        display: flex;\n    }\n\n    .logo-header {\n        padding: 16px;\n        min-width: unset;\n        max-width: unset;\n    }\n\n    .main-header .header-right {\n        padding: 16px;\n    }\n\n    .profile-dropdown .profile-pic {\n        min-width: 38px;\n        max-width: 38px;\n        height: 38px;\n    }\n\n    .profile-dropdown .dropdown-toggle {\n        gap: 4px;\n    }\n\n    .profile-dropdown .profile-info {\n        margin-left: 8px;\n    }\n\n    .admin-page {\n        padding: 16px;\n    }\n\n    .page-section-title {\n        font-size: 24px;\n        line-height: 28px;\n    }\n\n    .buildings-filter,\n    .import-data-page .create-building-form {\n        padding: 16px;\n    }\n\n    .create-building-form .button-group {\n        gap: 16px;\n    }\n\n    .bar-button {\n        display: flex;\n    }\n\n    .main-layout::before {\n        content: '';\n        width: 100%;\n        height: 100dvh;\n        position: fixed;\n        top: 0;\n        left: -100%;\n        background: #00000030;\n        pointer-events: none;\n        z-index: 98;\n        transition: all 0.3s ease-in-out;\n    }\n\n    .sidebar-open .sidebar,\n    .sidebar-open .main-layout::before {\n        left: 0;\n    }\n\n    .sidebar-open {\n        overflow: hidden;\n    }\n\n    .build-box-title {\n        font-size: 20px;\n        line-height: 28px;\n    }\n\n    .build-details-card {\n        padding: 16px;\n    }\n\n    .period-table thead th,\n    .build-details-card li p {\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .import-data-page .create-building-form {\n        margin-bottom: 24px;\n    }\n\n    .radio_list_import {\n        gap: 16px;\n    }\n\n    .radio_list_import label span {\n        min-width: 200px;\n        font-size: 16px;\n        line-height: 24px;\n        padding: 12px 25px;\n    }\n}\n\n@media only screen and (max-width:767px) {\n    .stat-value {\n        font-size: 32px;\n        line-height: 40px;\n    }\n\n\n    .auth-images,\n    .auth-login-box {\n        width: 100%;\n    }\n\n    .auth-login-box {\n        margin-top: 24px;\n    }\n\n    .auth-page {\n        padding: 16px;\n    }\n\n    .auth-form {\n        padding: 0;\n        max-width: 100%;\n    }\n\n    .auth-images h1 {\n        font-size: 34px;\n        line-height: 40px;\n    }\n\n    .auth-images p {\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .auth-form h2 {\n        font-size: 32px;\n        line-height: 38px;\n    }\n\n    .remeber-forgot-box,\n    .auth-form-title {\n        margin-bottom: 24px;\n    }\n\n    .btns {\n        font-size: 16px;\n        line-height: 22px;\n        padding: 12px 24px;\n        border-radius: 12px;\n    }\n\n    .buildings-filter {\n        flex-direction: column;\n    }\n\n    .buildings-filter .form-row {\n        max-width: 100%;\n    }\n\n    .build-details-card.build-full-active {\n        padding-right: 16px;\n        padding-top: 45px;\n    }\n\n    .build-full-active .status {\n        top: 16px;\n        right: 16px;\n        padding: 4px 12px;\n        font-size: 14px;\n        line-height: 18px;\n    }\n\n    .period-table thead th {\n        padding: 0 8px 12px;\n    }\n\n    .period-table tbody td {\n        padding: 12px 8px;\n    }\n\n    .auth-row {\n        flex-wrap: wrap;\n    }\n\n    .auth-images {\n        max-width: 100%;\n    }\n\n    .uploaded-surface-box {\n        margin-top: 24px;\n        padding: 16px;\n    }\n\n    .uploaded-surface-section .inner-title {\n        font-size: 16px;\n        line-height: 24px;\n        margin-bottom: 18px;\n    }\n\n    .auth-page .btns {\n        border-radius: 12px;\n        padding: 12px 24px;\n        font-size: 18px;\n        line-height: 20px;\n    }\n}\n\n@media only screen and (max-width:640px) {\n    .create-building-form .button-group {\n        flex-wrap: wrap;\n    }\n\n    .create-building-form .button-group .btns {\n        width: 100%;\n    }\n\n    .my-team-page .admin-page-title {\n        flex-direction: column;\n        align-items: flex-start !important;\n        gap: 16px !important;\n    }\n\n    .my-team-page .admin-page-title .btns {\n        margin-left: auto;\n    }\n\n    .radio_list_import label,\n    .radio_list_import label span {\n        width: 100%;\n    }\n\n    .uploaded-area-box .dropzone-content p {\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .uploaded-surface-item {\n        padding: 12px 35px 12px 16px;\n    }\n\n    .uploaded-surface-item .remove-btn {\n        right: 12px;\n    }\n\n    .import-data-page .btns {\n        width: fit-content;\n        min-width: unset;\n    }\n\n    .import-step-date .step {\n        min-width: 44px;\n        height: 44px;\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    .import-step-date {\n        gap: 80px;\n    }\n\n    .import-step-date .step::before {\n        width: 70px;\n        left: -75px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
